
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import Box from '@/components/common/flex-message/components/Box.vue'
import Image from '@/components/common/flex-message/components/Image.vue'
import Button from '@/components/common/flex-message/components/Button.vue'
import Video from '@/components/common/flex-message/components/Video.vue'
import Icon from '@/components/common/flex-message/components/Icon.vue'
import Text from '@/components/common/flex-message/components/Text.vue'
import Span from '@/components/common/flex-message/components/Span.vue'
import Separator from '@/components/common/flex-message/components/Separator.vue'
import Filler from '@/components/common/flex-message/components/Filler.vue'
@Options({
  components: { Filler, Separator, Span, Text, Box, Button, Icon, Image, Video },
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class FlexMessageComponents extends Vue {
  @Prop()
  direction!: string

  @Prop()
  type!: string

  @Prop()
  component!: {}

  @Prop()
  parentLayout!: string

  @Prop()
  parentSpacing!: string

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  initListNode(path) {
    this.$emit('initListNode', path)
  }
}
